var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DatePipe } from '@angular/common';
import { PipeTransform } from '@angular/core';
import { getTimezoneAbbreviation } from '@services/date.service';
var KortoDateTimePipe = /** @class */ (function (_super) {
    __extends(KortoDateTimePipe, _super);
    function KortoDateTimePipe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KortoDateTimePipe.prototype.transform = function (value, args) {
        var zoneAbbr = args === 'noTz' ? ' ' : getTimezoneAbbreviation();
        return _super.prototype.transform.call(this, value, "yyyy/MM/dd, h:mm a '" + zoneAbbr + "'");
    };
    return KortoDateTimePipe;
}(DatePipe));
export { KortoDateTimePipe };
